import React, { useState } from 'react'
import {
    Box,
    Button,
    Flex,
    Icon,
    Input,
    InputGroup,
    InputRightElement,
    Text,
    chakra,
} from '@chakra-ui/react'
import { ArrowRight } from 'emotion-icons/heroicons-outline'
import { BlogTag, TagId } from 'entities/tag'
import { routes } from 'routes'
import { toggleElement } from 'lib/array'
import { NewsLetterTags } from 'containers/blogs/components/newsletter/components/NewsLetterTags'
import { NewsLetterState } from 'containers/blogs/components/newsletter/types'
import { Heading } from 'components/Heading'
import Newsletter from 'public/img/newsletter.svg'

const NewsletterChakra = chakra(Newsletter)

const ICON_WIDTH = '194px'
const MD_GRID_GAP = '48px'

export const NewsLetter = ({
    setOnSubmit,
    tags,
}: {
    setOnSubmit: () => void
    tags: Pick<BlogTag, 'id' | 'label'>[] & {}
}) => {
    const collapsedTagCount = 10
    const expandedTagCount = 20
    const collapsedTags = tags?.slice(0, collapsedTagCount)
    const expandedTags = tags?.slice(0, expandedTagCount)

    const [state, setState] = useState<NewsLetterState>({
        email: '',
        currentTags: collapsedTags,
        selectedTagIds: [],
    })

    const handleTagClick = (id: TagId): void => {
        setState({
            ...state,
            selectedTagIds: toggleElement(state.selectedTagIds, id),
        })
    }
    const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setState({
            ...state,
            email: e.target.value,
        })
    }
    const handleShowMoreClick = (isExpanded: boolean) => {
        setState({
            ...state,
            currentTags: isExpanded ? expandedTags : collapsedTags,
        })
    }

    const onSubmit = (e: React.FormEvent) => {
        e.preventDefault()

        // TODO [DEV-997]: Do not submit if no tags are selected, show error.
        fetch(
            routes.api.createProspect({
                email: state.email,
                selectedTags: state.selectedTagIds,
            }),
            {
                method: 'POST',
            },
        ).then(() => {
            setOnSubmit()
        })
    }

    return (
        <Flex
            justifyContent="center"
            align="center"
            gridGap={{ base: '32px', md: MD_GRID_GAP }}
            wrap="wrap"
            w="100%"
            h="100%"
            borderRadius="12px"
            as="form"
            onSubmit={onSubmit}
        >
            <Box
                maxW={{
                    base: '100%',
                    lg: `calc(100% - ${ICON_WIDTH} - ${MD_GRID_GAP})`,
                }}
            >
                <Heading as="h3" variant={'blogPageTitle'} mb="24px">
                    Subscribe to our newsletter
                </Heading>
                <Text variant="bodyTextSmall" fontWeight={600} mb="16px">
                    {`I'd like to see more content and job opportunities related to...`}
                </Text>
                <NewsLetterTags
                    collapsedTagCount={collapsedTagCount}
                    state={state}
                    tags={tags}
                    handleTagClick={handleTagClick}
                    handleShowMoreClick={handleShowMoreClick}
                />
                <Box mt="37px" maxWidth="421px">
                    <InputGroup>
                        <Input
                            type="email"
                            variant="outline"
                            colorScheme="secondary"
                            h="56px"
                            isRequired={true}
                            borderColor="transparent"
                            fontSize={{ base: '16px', md: '18px' }}
                            fontWeight={500}
                            placeholder="Enter your email"
                            onChange={onChangeHandler}
                        />
                        <InputRightElement w="50px" mt="8px" mr="4px">
                            <Button
                                type="submit"
                                colorScheme="secondary"
                                size="sm"
                                py="24px"
                                px="14px"
                                borderRadius="12px"
                            >
                                <Icon
                                    fontSize="24px"
                                    as={ArrowRight}
                                    strokeWidth="2.5px"
                                />
                            </Button>
                        </InputRightElement>
                    </InputGroup>
                </Box>
            </Box>
            <NewsletterChakra width={ICON_WIDTH} height="210px" />
        </Flex>
    )
}
